import React from 'react';
import PropTypes from 'prop-types';
import of from 'await-of';
import { roAPI } from '#utils/axiosAPI';
import { storeToken } from '#utils/authService';
import styles from './formLogin.module.css';
import { Input } from '../../UI/input/input';
import { Controller, useForm } from 'react-hook-form';
import { Field, FieldError, FieldLabel } from '../../UI/form/form';

const FormLogin = ({ onAfterSubmit }) => {
  const form = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const handleFormSubmit = async data => {
    const [res, error] = await of(
      roAPI.post('/auth/login', {
        email: data.email,
        password: data.password,
      }),
    );
    if (error && error.response && error.response.data.type === 'Auth/UserNotActivated') {
      onAfterSubmit('/auth/activate', 'redirect');
    } else if (!error) {
      storeToken(res.token);
      onAfterSubmit(res.token);
    }
  };

  return (
    <div data-testid="FormLogin">
      <form className={styles.form} onSubmit={form.handleSubmit(handleFormSubmit)} id="formLogin">
        <div className={styles['field-group']}>
          <Controller
            control={form.control}
            name="email"
            rules={{
              required: {
                value: true,
                message: 'El correo electrónico es obligatorio.',
              },
              pattern: { value: /^\S+@\S+$/i, message: 'El correo electrónico es inválido.' },
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="email">
                  Correo electrónico
                </FieldLabel>
                <Input {...field} id="email" aria-invalid={fieldState.invalid} placeholder="Correo electrónico" autoComplete="on" />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />

          <Controller
            control={form.control}
            name="password"
            rules={{
              required: {
                value: true,
                message: 'La contraseña es obligatoria.',
              },
            }}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid}>
                <FieldLabel data-invalid={fieldState.invalid} htmlFor="password">
                  Contraseña
                </FieldLabel>
                <Input
                  {...field}
                  id="password"
                  aria-invalid={fieldState.invalid}
                  type="password"
                  placeholder="Contraseña"
                  autoComplete="on"
                />
                {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
              </Field>
            )}
          />
        </div>

        <button type="submit" className={`btn btn-une ${styles['btn-submit']}`}>
          Iniciar sesión
        </button>
      </form>
    </div>
  );
};

FormLogin.propTypes = {
  onAfterSubmit: PropTypes.func,
};

FormLogin.defaultProps = {
  onAfterSubmit: f => f,
};

export default FormLogin;
